var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-fade" } }, [
    _vm.visible
      ? _c(
          "div",
          {
            staticClass: "mask",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.$emit("close")
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "app-popup",
                class: {
                  "app-popup--success": _vm.isTypeSuccess,
                  "app-popup--warning": _vm.isTypeWarning,
                  "app-popup--danger": _vm.isTypeDanger
                }
              },
              [
                _c("p", { staticClass: "app-popup__title" }, [
                  _vm._v("\n\t\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "app-popup__message" }, [
                  _vm._v("\n\t\t\t\t" + _vm._s(_vm.message) + "\n\t\t\t")
                ]),
                _vm._v(" "),
                _vm.$slots.default
                  ? _c(
                      "div",
                      { staticClass: "app-popup__buttons" },
                      [_vm._t("default")],
                      2
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35cfea78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35cfea78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppPopup.vue
// module id = null
// module chunks = 